import {requests} from "../../helpers/api.services";
import {GALLERY_SETTINGS_URL} from "../../helpers/api.routes";

export const AdminGallerySettingsService = {
    get: () => requests.get(GALLERY_SETTINGS_URL),
    create: (params: any) => requests.post(GALLERY_SETTINGS_URL, params)
}